import { ScrollText } from 'lucide-react';
import { t } from '@lingui/core/macro';

import { FormModalWrapper } from '@duke-hq/ui/components/Modals/FormModalWrapper';
import { useBulkInternalEnrolments } from '@duke-hq/app-provider-web/tenant/components/BulkEnrolments/useBulkInternalEnrolments';
import { TeamBulkEnrolments } from '@duke-hq/app-provider-web/tenant/Team/TeamBulkEnrolments/TeamBulkEnrolments';
import { useTenantContext } from '../../TenantContext';

export function TeamBulkEnrolmentsFormModal() {
  const { isModalOpen, openModal, closeModal } = useBulkInternalEnrolments();
  const tenantCtx = useTenantContext();

  if (tenantCtx != null && tenantCtx.permissions.includes('canCreateInternalEnrolments') == false) {
    return null;
  }

  return (
    <FormModalWrapper
      modalOpenButtonText={t`Create internal enrolment`}
      modalOpenButtonLeftIcon={ScrollText}
      modalContent={<TeamBulkEnrolments />}
      isOpen={isModalOpen}
      onClose={closeModal}
      onOpen={openModal}
      modalContentHeight="auto"
    />
  );
}
